import gql from 'graphql-tag';

// @TODO This is the proper query, but need to solve for the actual consumer card.
// const getGlobalLayoutCard = gql`
//   query getGlobalLayoutCard {
//     getGlobalLayoutCard {
//       id
//       card_side_groups {
//         total
//         records {
//           id
//           side
//           card_sides {
//             total
//             records {
//               id
//             }
//           }
//         }
//       }
//     }
//   }
// `;

const getGlobalLayoutCard = gql`
  query getGlobalLayoutCard {
    globalLayoutCard {
      id
      card_side_groups {
        total
        records {
          id
          side
          card_sides {
            total
            records {
              id
            }
          }
        }
      }
    }
  }
`;

export default getGlobalLayoutCard;
